import React from "react";
import DirectorsPage from "@pages/Directors/DirectorsPage";
import DirectorEditorPage from "@pages/Directors/DirectorEditorPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";
import InviteDirectorSuccessPage from "@pages/Directors/InviteDirectorSuccessPage/InviteDirectorSuccessPage";

export default [
    {
        path: "users",
        element: <ProtectedRoute allowedRoles={["root_admin", "business_admin", "demo"]} />,
        children: [
            {
                path: "",
                element: <DirectorsPage />,
            },
            {
                path: "editor",
                element: <DirectorEditorPage />,
            },
            {
                path: "invite-success",
                element: <InviteDirectorSuccessPage />,
            },
        ],
    },
];
